import React from 'react'
import bgImage from '../../assets/servicesImages/ml/hero.png'
import pic1 from '../../assets/servicesImages/ml/1.png'
import pic2 from '../../assets/servicesImages/ml/2.png'
import pic3 from '../../assets/servicesImages/ml/3.png'
import pic4 from '../../assets/servicesImages/ml/4.png'
import a from '../../assets/servicesImages/ml/a.png'
import b from '../../assets/servicesImages/ml/b.png'
import c from '../../assets/servicesImages/ml/c.png'
import a1 from '../../assets/servicesImages/ml/1a.png'
import b1 from '../../assets/servicesImages/ml/1b.png'
import c1 from '../../assets/servicesImages/ml/1c.png'
import ml from '../../assets/servicesImages/ml/ml.png'
import icon1 from '../../assets/servicesImages/ml/icon1.png'
import icon2 from '../../assets/servicesImages/ml/icon2.png'
import icon3 from '../../assets/servicesImages/ml/icon3.png'
import Slider from 'react-slick'
import imagea from '../../assets/servicesImages/ai/a.png'
import arrow from '../../assets/viewdetails.png'

const items = [
    {
        image: imagea,
        desc: 'Expertise: Our team comprises experienced AI professionals with deep knowledge across various industries.'
    },
    {
        image: imagea,
        title: 'Sales & Purchase Management',
        desc: 'Increase Productivity & Lower Costs By Managing Your Sales & Purchased. It Manages complete cycle from Purchases to Sales Order.'
    },
    {
        image: imagea,
        title: 'Sales & Purchase Management',
        desc: 'Increase Productivity & Lower Costs By Managing Your Sales & Purchased. It Manages complete cycle from Purchases to Sales Order.'
    },
]

const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    slidesToShow: 4,
    speed: 500,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
        {
            breakpoint: 3000, // large screens default
            settings: {
                slidesToShow: 4,
            },
        },
        {
            breakpoint: 1024, // md to lg
            settings: {
                slidesToShow: 2.5,
                centerMode: false,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                centerMode: false,
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                centerMode: false,
            }
        }
    ]
    
};

const settings2 = {
    className: "center",
    centerMode: true,
    infinite: true,
    slidesToShow: 3,
    speed: 500,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
        {
            breakpoint: 3000, // large screens default
            settings: {
                slidesToShow: 4,
            },
        },
        {
            breakpoint: 1024, // md to lg
            settings: {
                slidesToShow: 2.5,
                centerMode: false,
            },
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                centerMode: false,
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                centerMode: false,
            }
        }
    ]
    };


const item = [
    {
        icon: a1,
        title: 'Consultation and Assessment',
        desc: 'We begin by understanding your business objectives and challenges. Our team conducts a thorough assessment to identify opportunities where ML can add value.'
    },
    {
        icon: b1,
        title: 'Data Preparation',
        desc: 'We gather, clean, and preprocess your data to ensure it’s ready for analysis. This step is crucial for building accurate and reliable models.'
    },
    {
        icon: c1,
        title: 'Model Development',
        desc: 'Using the latest ML algorithms and tools, we develop models tailored to your specific needs. We rigorously test and validate these models to ensure they meet your requirements.'
    },
]

const cards = [
    {
        image: pic1,
        tile: 'Data Visualization & Processing',
        desc: 'Collect, clean, and organize data for analysis. Visualize it to highlight key trends and insights for decision-making.',
    },
    {
        image: pic2,
        tile: 'Automates Repetitive Tasks',
        desc: 'Boost efficiency with automation by using bots or scripts to handle routine processes without manual input.',
    },
    {
        image: pic3,
        tile: 'Analyzing Massive Data Volumes',
        desc: 'Use powerful tools to handle large datasets, extract insights, and support strategic planning.',
    },
    {
        image: pic4,
        tile: 'Recognizes Complex Patterns',
        desc: 'Advanced algorithms detect intricate patterns in data, uncovering hidden relationships and correlations.',
    }
]

const ML = () => {
    return (
        <div className='flex flex-col gap-20'>

  {/* Hero Section */}
  <div className='h-[40vh] md:h-[50vh] lg:h-screen w-full text-white flex justify-start items-center pt-24 relative bg-cover bg-center'

    style={{ backgroundImage: `url(${bgImage})` }}
  >
    <div className="absolute inset-0 bg-black bg-opacity-50 z-0"></div>
    <div className='relative z-10 p-6 sm:p-10 max-w-xl sm:max-w-2xl md:max-w-3xl lg:max-w-4xl'>
      <h1 className='text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6'>Machine Learning Services</h1>
      <p className='text-base sm:text-lg'>
        We help businesses predict user behavior, improve upsells, and optimize workflows using advanced ML solutions.
      </p>
    </div>
  </div>

  {/* Features */}
  <section className='px-4 sm:px-8 lg:px-28 text-center flex flex-col gap-6 sm:gap-8'>
    <h2 className='text-2xl sm:text-3xl font-bold'>Features of Machine Learning</h2>
    <p className='text-sm sm:text-base text-gray-700'>
      From automation to advanced analytics, our ML services are built for scalability, accuracy, and real-world impact across your operations.
    </p>
    <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 pt-8 sm:pt-10'>
      {cards.map((item, i) => (
        <div key={i} className='bg-white rounded-xl shadow-lg p-4 hover:shadow-2xl transition-all duration-300 hover:scale-[1.02] hover:text-blue-800'>
          <img src={item.image} alt={item.tile} className='rounded-t-lg mb-4 w-full h-[150px] object-cover' />
          <h3 className='text-lg sm:text-xl font-semibold mb-2 text-[#333]'>{item.tile}</h3>
          <p className='text-sm text-gray-600 text-justify'>{item.desc}</p>
        </div>
      ))}
    </div>
  </section>

  {/* ML Solutions */}
  <section className='px-4 sm:px-8 lg:px-28 text-center'>
    <h2 className='text-2xl sm:text-3xl font-semibold mb-4 sm:mb-6 '>Our Machine Learning Solutions</h2>
    <p className='text-sm sm:text-base leading-relaxed mb-6 sm:mb-10'>
      Our machine learning solutions leverage advanced algorithms to analyze data and generate insights...
    </p>
    <div className='flex flex-wrap justify-center gap-4 sm:gap-6 pt-4 sm:pt-6'>
      {[a, b, c].map((img, idx) => (
        <img key={idx} src={img} alt='solution' className='w-[260px] sm:w-[300px] h-auto rounded-xl shadow-md hover:scale-105 transition' />
      ))}
    </div>
  </section>

  {/* Why Choose Us */}
  <section className='px-4 sm:px-8 md:px-28 text-center'>
  <h2 className='text-2xl sm:text-3xl font-semibold mb-6 sm:mb-10'>Why Choose Us?</h2>
  <div className='flex flex-col md:flex-row justify-center items-center gap-6 sm:gap-10'>
    <img src={ml} alt='' className='w-[80%] sm:w-[500px] md:w-[500px]' />
    <div className='space-y-4 sm:space-y-6 text-left'>
      {[{ icon: icon1, title: 'Expertise', desc: 'Our team of seasoned data scientists and ML engineers...' },
        { icon: icon2, title: 'Custom Solutions', desc: 'We understand every business is unique...' },
        { icon: icon3, title: 'End-to-End Support', desc: 'From consultation to deployment...' }
      ].map((entry, idx) => (
        <div key={idx} className='flex gap-4'>
          <img src={entry.icon} alt='' className='w-6 h-6 sm:w-8 sm:h-8' />
          <div>
            <h3 className='text-lg sm:text-xl font-semibold'>{entry.title}</h3>
            <p className='text-sm text-gray-700'>{entry.desc}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>


         {/* ML Process Steps - Carousel */}
<section className='px-8 lg:px-28'>
<h2 className='text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6 md:mb-8 lg:mb-10'>
  Our ML Process
</h2>
  <Slider {...settings2}>
    {item.map((step, i) => (
      <div key={i} className='p-4'>
        <div className='bg-white shadow-md rounded-xl p-4 flex flex-col items-center text-center h-[280px] '>
          <img src={step.icon} alt={step.title} className='w-[50px] mb-3' />
          <h4 className='font-bold text-base mb-2'>{step.title}</h4>
          <p className='text-gray-600 text-sm'>{step.desc}</p>
        </div>
      </div>
    ))}
  </Slider>
</section>

            {/* Final Carousel */}
            <section className='px-8 lg:px-28 mb-5'>
            <h2 className='text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold mb-4 sm:mb-6 md:mb-8 lg:mb-10'>
  Why Choose Esparse Matrix Solutions?
</h2>
  <Slider {...settings}>
    {items.map((el, i) => (
      <div key={i} className='p-2'>
        <div className='bg-white shadow-lg rounded-xl overflow-hidden h-[320px] flex flex-col'>
          <img src={el.image} alt='feature' className='w-full h-[150px] object-cover' />
          <div className='p-4 flex flex-col justify-between flex-1'>
            <p className='text-sm text-gray-700 mb-2'>{el.desc}</p>
            <a href="/" className='flex items-center text-blue-600 text-sm hover:underline mt-auto'>
              View Details
              <img src={arrow} alt='arrow' className='ml-2 w-3' />
            </a>
          </div>
        </div>
      </div>
    ))}
  </Slider>
</section>

        </div>
    )
}

export default ML
